import Create from "./Create";
import Stats from "./Stats";
import Table from "./Table";

function Amenities() {
  return (
    <div>
        <Stats />
        <Table />
        <Create />
    </div>
  );
}

export default Amenities;
